<!--  -->
<template>
  <div class="">
    <div class="historychoose">
      <h2>请选择日期范围查询<span>{{ realName }}</span><span style="color:#4da1eb">动态血糖</span>检测记录</h2>
      <el-form ref="form" :model="form">
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择起始日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <span slot="label">
            <span class="form-name"> 选择截止日期 </span>
          </span>
          <el-col :span="11" class="blank">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date2" style="width: 100%"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-col :span="2">
          <div class="blank"></div>
        </el-col>
        <el-form-item>
          <el-button class="xingou-blue" type="primary" @click="querylistByTime()">确认查询</el-button>
          <el-button type="primary" plain @click="queryAll()">查询所有记录</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" height="600" :header-cell-style="tableHeaderColor" border stripe style="width: 100%"
        :cell-style="{ fontSize: '16px' }" v-loading="loadingShow" element-loading-text="数据正在加载中"
        :default-sort="{ prop: 'startTime', order: 'descending' }">
        <el-table-column type="index" align="center">
        </el-table-column>
        <el-table-column prop="startTime" label="监测开始时间" align="center" sortable width="170">
        </el-table-column>
        <el-table-column prop="endTime" label="监测结束时间" align="center" width="170">
        </el-table-column>
        <el-table-column prop="totalTime" label="时长" align="center" width="120">
        </el-table-column>
        <el-table-column prop="theDay" label="第几天" align="center" width="90">
        </el-table-column>
        <el-table-column prop="statusName" label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">{{ scope.row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="finishName" label="是否完成" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.finished ? 'success' : 'warning'" size="small">{{ scope.row.finishName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="deviceSn" label="设备SN" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="read" label="操作" align="center" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium"
              style="font-size: 16px;">查看记录</el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除" align="center" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        date1: '',
        date2: '',
      },
      tableData: [],
      loadingShow: true,
      realName: '',
      uid: '',
    };
  },
  methods: {
    TimeProcess(time) {
      let y = time.getFullYear();
      let MM = time.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = time.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + MM + '-' + d;
    },
    formatDuration(seconds) {
      seconds = Number(seconds) || 0;
      let d = Math.floor(seconds / 86400);
      let h = Math.floor((seconds % 86400) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let s = seconds % 60;
      if (d > 0) return d + '天' + h + '小时' + m + '分';
      if (h > 0) return h + '小时' + m + '分';
      if (m > 0) return m + '分' + s + '秒';
      return s + '秒';
    },
    formatValue(value) {
      return value === null || value === undefined || value === '' ? '--' : value;
    },
    pickValue(item, fields) {
      for (let i = 0; i < fields.length; i++) {
        const value = item[fields[i]];
        if (value !== null && value !== undefined && value !== '') {
          return value;
        }
      }
      return null;
    },
    getStatusInfo(status) {
      const statusNumber = Number(status);
      if (statusNumber === 1) {
        return { statusName: '监测中', finishName: '未完成', finished: false };
      }
      if (statusNumber === 2) {
        return { statusName: '已结束', finishName: '已完成', finished: true };
      }
      return { statusName: '--', finishName: '--', finished: false };
    },
    processTableData(list) {
      return (list || []).map(item => {
        const latestValue = this.pickValue(item, ['latestValue', 'lastValue', 'value', 'glucoseValue', 'bloodGlucose']);
        const avgValue = this.pickValue(item, ['avgValue', 'averageValue', 'meanValue']);
        const minValue = this.pickValue(item, ['minValue', 'minimumValue']);
        const maxValue = this.pickValue(item, ['maxValue', 'maximumValue']);
        const statusInfo = this.getStatusInfo(item.status);
        return {
          ...item,
          latestValue,
          avgValue,
          minValue,
          maxValue,
          latestValueText: this.formatValue(latestValue),
          avgValueText: this.formatValue(avgValue),
          minValueText: this.formatValue(minValue),
          maxValueText: this.formatValue(maxValue),
          totalTime: this.formatDuration(item.duration),
          ...statusInfo,
        };
      });
    },
    querylistByTime() {
      if (!this.form.date1) {
        this.$message.warning('请选择起始日期');
        return;
      }
      if (!this.form.date2) {
        this.form.date2 = new Date();
      }
      this.loadingShow = true;
      const startTime = this.TimeProcess(this.form.date1);
      const endTime = this.TimeProcess(this.form.date2);
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodglucose/app/list'),
        method: 'post',
        data: this.$http.adornData({ uid: this.uid, startTime, endTime }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false;
          this.tableData = this.processTableData(data.data || []);
        } else {
          this.loadingShow = false;
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.loadingShow = false;
        this.$message.error('数据加载失败');
      });
    },
    queryAll() {
      this.loadingShow = true;
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodglucose/app/list'),
        method: 'post',
        data: this.$http.adornData({ uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.loadingShow = false;
          this.tableData = this.processTableData(data.data || []);
        } else {
          this.loadingShow = false;
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.loadingShow = false;
        this.$message.error('数据加载失败');
      });
    },
    handleClick(row) {
      this.$router.push({
        name: 'HistoryDynamicBloodGlucose2',
        query: {
          id: row.id,
          uid: row.uid,
          RecordCreatetime: row.startTime || row.createTime,
          totalTime: row.totalTime,
          latestValue: row.latestValue,
          avgValue: row.avgValue,
          minValue: row.minValue,
          maxValue: row.maxValue,
          sampleCount: row.sampleCount,
          status: row.status,
          deviceSn: row.deviceSn,
          theDay: row.theDay,
        },
      });
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.splice(index, 1);
        this.$message({ type: 'success', message: '删除成功!' });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    tableHeaderColor() {
      return 'color:#000 ;font-size:18px;text-align:center';
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl('/personal/info/getBasicInfo'),
        method: 'get',
        params: this.$http.adornParams({ uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.realName = data.realName;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
  created() {
    if (this.$route.query.crossPlatform != null && this.$route.query.crossPlatform != undefined) {
      this.crossPlatformStatus = true;
    }
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    } else {
      this.uid = this.$store.state.personal_module.uid;
    }
  },
  mounted() {
    this.queryAll();
    this.getinfo();
  },
};
</script>

<style scoped>
.blank {
  border-radius: 4px;
  height: 18px;
}

.form-name {
  display: inline-block;
  font-weight: bold;
  font-size: 18px;
}

.xingou-blue {
  color: #fff;
  background-color: #428bca;
  border-color: #428bca;
}

.xingou-blue:hover,
.xingou-blue:focus {
  background: #4da1eb;
  border-color: #4da1eb;
  color: #fff;
}
</style>
